import React, { useState, useContext } from "react";
import { BotaoMenor, BotaoError, Spinner } from "../StyledComponent";
import { Link } from "react-router-dom";
import MsgFirstAccess from "./MsgFirstAccess";
import { Context } from "../../services/auth";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Close from "../Reutilizaveis/CloseButton";
import Fade from "@material-ui/core/Fade";
import { maskCpfCnpj } from "../../Utils/masks";
import "./styles.scss";

export const FirstAccess = () => {
  const [cpfcnpj, setCpfcnpj] = useState("");

  const [cpfFound, setCpfFound] = useState(false);

  const [showMsg, setShowMsg] = useState(false);

  const { handleFirstAccess } = useContext(Context);

  const [loading, setLoading] = useState(false);

  const [invalidAccess, setInvalidAccess] = useState(false);

  const [userEmail, setUserEmail] = useState("");

  const [info, setInfo] = useState(false);

  const [senha, setSenha] = useState("");

  const [msgUserNotActive, setMsgUserNotActive] = useState(false);

  async function cadastraCPF(event) {
    event.preventDefault();

    setLoading(true);

    // verifica CPF se está ou não cadastrado no banco de dados
    const result = await handleFirstAccess(cpfcnpj);

    checkIfValidAccess(result);
  }

  async function checkIfValidAccess(result) {
    if (result?.status == "500" || result?.status == "400") {
      setInfo(false);
      setLoading(false);
      if (result?.data.Falha != undefined) {
        setMsgUserNotActive(true);
      } else {
        setInvalidAccess(true);
      }
    } else {
      setUserEmail(result?.email);
      setSenha(result?.senha);
      setCpfFound(true);
      setShowMsg(true);
    }
  }


  const reset = (event) => {
    event.preventDefault();
    setCpfcnpj("");
    setInfo(false);
    setInvalidAccess(false);
    setMsgUserNotActive(false);
    return;
  };

  return (
    <div>
      {/* se CPF encontrado, irá exibir o componente para cadastro de senha, caso contrário irá exibir uma mensagem de erro */}
      {showMsg && (
        <MsgFirstAccess
          cpfEncontrado={cpfFound}
          cpf={senha}
          userEmail={userEmail}
        />
      )}
      {!showMsg && (
        <div className="loginForm centralized-column">
          <form
            onSubmit={cadastraCPF}
            className="first-access centralized-column"
          >
            <div className="first-access__title centralized">
              <h1>Primeiro acesso:</h1>
            </div>
            <div className="information">
              <input
                id="txtUserName"
                type="text"
                placeholder="CPF / CNPJ"
                required
                value={cpfcnpj}
                onChange={(event) => setCpfcnpj(maskCpfCnpj(event.target.value))}
              />
              <Fade in>
                <span
                  style={{
                    position: "absolute",
                    top: "27px",
                    right: "-14px",
                    zIndex: "999999",
                    cursor: "pointer",
                    visibility: cpfcnpj != "" ? "visible" : "hidden",
                  }}
                  onClick={() => {
                    setCpfcnpj("");
                  }}
                >
                  <Close
                    tamanho="20px"
                    tamanhoIcone="10px"
                    corBackground="#ffffff"
                  />
                </span>
              </Fade>
              <p className="first-access__obrigatorio">Campo obrigatório*</p>
              <span
                onClick={(event) => {
                  event.preventDefault();
                  setInfo(!info);
                }}
              >
                {invalidAccess && (
                  <InfoOutlinedIcon
                    style={{ fill: "#B61817" }}
                    className="information__icon"
                    id="iconInformation"
                  />
                )}

                {!invalidAccess && (
                  <InfoOutlinedIcon className="information__icon" />
                )}
              </span>
            </div>
            {loading && <Spinner />}
            {!loading && (invalidAccess || msgUserNotActive) && (
              <BotaoError
                id="bntTryAgain"
                onClick={(event) => {
                  reset(event);
                }}
              >
                DOCUMENTO INVÁLIDO
              </BotaoError>
            )}
            {!loading && !invalidAccess && !msgUserNotActive && (
              <BotaoMenor
                id="bntRegister"
                disabled={cpfcnpj.length >= 11 ? false : true}
                // width="100%"
              >
                Cadastrar
              </BotaoMenor>
            )}
          </form>
          <div className="toLogin">
            <Link className="toLogin__link" to="/" id="btnAlreadyRegistered">
              Já tenho cadastro
            </Link>
          </div>
          {msgUserNotActive && !info && (
            <div className="errorMsg">
              <p style={{ color: "#B61817" }}>
                Identificamos que você ainda não é nosso cliente, caso já tenha
                assinado contrato conosco e tenha menos de 7 dias, entre em
                contato pela Central de Relacionamento ligando para 4002- 2600,
                pois pode ser que seu cadastro não esteja completo ainda.
              </p>
            </div>
          )}
          {invalidAccess && !info && (
            <div className="errorMsg">
              <p>
                Esse <b>Documento está incorreto</b> ou já pode ter efetuado o{" "}
                <b>
                  &quot;Primeiro acesso&quot;, caso tenha pausado a construção
                  do seu primeiro acesso,
                </b>{" "}
                utilize o <b>&quot;esqueceu sua senha&quot;</b> na tela de
                login.
              </p>
              <p style={{ color: "#7C7C7C" }}>
                Caso não lembre seus dados,
                <b>favor entrar em contato com nosso suporte.</b>
              </p>
            </div>
          )}

          {info && (
            <div className="errorMsg">
              <p>
                A sua conta é uma junção de outras ferramentas de autenticação
                já existentes caso seja proprietário de um ou mais imóveis da
                Direcional ou Riva Incorporadora.
              </p>
              <p>
                Caso seu documento não seja valido, favor entrar em contato com
                nosso suporte.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
